import { setState, state } from '../..';
import { Mapped, View } from '../..';
import {
    ChallengeByCategoryView, ChallengeView, defaultActionView, defaultChallengesByCategoryView,
    defaultChallengesView, GameActionView
} from './challenge/ChallengeView.interface';
import { ChapterView, defaultChapterView } from './chapter/ChapterView.interface';
import { defaultDiscoverView, DiscoverView } from './discover/DiscoverView.interface';
import { defaultHomeView, HomeView } from './home/HomeView.interface';
import { defaultProfileView, ProfileView } from './profile/ProfileView.interface';
import { defaultQuizzesView, QuizzView } from './quizz/QuizzView.interface';
import { defaultStoryView, StoryView } from './story/StoryView.interface';

type Views = {
  home: View<HomeView>;
  challenges: Mapped<ChallengeView>;
  challengesByCategory: Mapped<ChallengeByCategoryView>;
  quizzes: Mapped<QuizzView>;
  chapters: Mapped<ChapterView>;
  actions: Mapped<GameActionView>;
  discover: View<DiscoverView>;
  story: View<StoryView>;
  profile: View<ProfileView>;
};

const defaultViewsState: Views = {
  home: defaultHomeView,
  challenges: defaultChallengesView,
  challengesByCategory: defaultChallengesByCategoryView,
  quizzes: defaultQuizzesView,
  discover: defaultDiscoverView,
  story: defaultStoryView,
  chapters: defaultChapterView,
  actions: defaultActionView,
  profile: defaultProfileView,
};

function updateView(payload: Partial<Views>, effect: string) {
  setState("VIEWS", { VIEWS: { ...state.VIEWS, ...payload } }, effect);
}

export { Views, defaultViewsState, updateView };
